import { Property } from "../../global/types";

const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined"
    ? window.location.origin
    : "https://www.7cantos.com");

export function isHashParam(id: string) {
  return id.length > 10;
}

export function buildPropertyJsonLd(property: Property, pageUrl: string) {
  const images =
    property.photos?.map((p) => p.url_l || p.url_m || p.url_s).filter(Boolean) ||
    [];
  const additionalProperty: { "@type": string; name: string; value: string }[] =
    [];
  if (property.rooms != null)
    additionalProperty.push({
      "@type": "PropertyValue",
      name: "Quartos",
      value: String(property.rooms),
    });
  if (property.bathrooms != null)
    additionalProperty.push({
      "@type": "PropertyValue",
      name: "Banheiros",
      value: String(property.bathrooms),
    });
  if (property.area != null)
    additionalProperty.push({
      "@type": "PropertyValue",
      name: "Área (m²)",
      value: String(property.area),
    });
  if (property.garages != null)
    additionalProperty.push({
      "@type": "PropertyValue",
      name: "Vagas",
      value: String(property.garages),
    });
  const product: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: property.title,
    description: property.description || property.title,
    image: images.length ? images : undefined,
    brand: { "@type": "Brand", name: "7Cantos" },
    category: "Aluguel de Imóveis",
    url: pageUrl,
    ...(additionalProperty.length ? { additionalProperty } : {}),
  };
  if (!isHashParam(String(property.id)) && property.rent_value != null) {
    product.offers = {
      "@type": "Offer",
      price: String(parseFloat(property.rent_value)),
      priceCurrency: "BRL",
      availability: property.is_rented
        ? "https://schema.org/SoldOut"
        : "https://schema.org/InStock",
      url: pageUrl,
    };
  }
  return product;
}

export function buildBreadcrumbJsonLd(property: Property, pageUrl: string) {
  const address = property.address;
  const city = address?.city || "Imóveis";
  const searchCityUrl =
    address?.city && address?.uf
      ? `${SITE_URL.replace(/\/$/, "")}/search?city=${encodeURIComponent(
          address.city
        )}&UF=${encodeURIComponent(address.uf)}`
      : `${SITE_URL.replace(/\/$/, "")}/search`;
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: `${SITE_URL.replace(/\/$/, "")}/`,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Buscar Imóveis",
        item: `${SITE_URL.replace(/\/$/, "")}/search`,
      },
      { "@type": "ListItem", position: 3, name: city, item: searchCityUrl },
      {
        "@type": "ListItem",
        position: 4,
        name: property.title,
        item: pageUrl,
      },
    ],
  };
}

export function getPropertyDetailsPageUrl(id: string) {
  return `${SITE_URL.replace(/\/$/, "")}/imovel/${id}`;
}
